export const useScrollLockForCookieConsent = () => {
  const scrollLockStore = useMyScrollLockStore();
  const ELEMENT_NAME = 'cookie_banner';

  onMounted(() => {
    const consentBannerElement = document.querySelector(
      '#onetrust-consent-sdk .onetrust-pc-dark-filter',
    );

    function toggleBodyScroll() {
      if (
        consentBannerElement &&
        getComputedStyle(consentBannerElement).display === 'none'
      ) {
        scrollLockStore.removePageScrollLockForElement(ELEMENT_NAME);
      } else if (consentBannerElement) {
        scrollLockStore.addPageScrollLockForElement(ELEMENT_NAME);
      }
    }

    toggleBodyScroll();

    // Observe changes in the consent banner's visibility
    const observer = new MutationObserver(toggleBodyScroll);
    if (consentBannerElement) {
      observer.observe(consentBannerElement, {
        attributes: true,
        attributeFilter: ['style'],
      });
    }
  });
};
